import API_URLS from '../../constants/api-urls';
import axios from '../../utils/axios';

export type AddToCartArgs = {
    material: { id: number; purchaseType: number } | { id: number; purchaseType: number }[];
};
type AddToCartResponse = { data: { items: { cart: Cart } } };

export const addToCart = (args: AddToCartArgs): Promise<Cart> =>
    (axios.post(`${API_URLS.CART}add`, args) as unknown as Promise<AddToCartResponse>).then(
        (response) => response.data.items.cart
    );
